import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import { getFromSource } from '@/utils/getImages';

export const EMPTY_AVATAR_VIEW = {
  INITIALS: 'INITIALS',
  DEFAULT: 'DEFAULT'
};

const UserAvatar = ({ user, src, emptyAvatarView, useOriginal, ...props }) => {
  const userAvatar = useMemo(() => {
    if (useOriginal) return user?.avatarOriginal;
    return src || user?.avatar || user?.avatarOriginal;
  }, [src, useOriginal, user?.avatar, user?.avatarOriginal]);

  return (
    <Avatar
      src={getFromSource(userAvatar)}
      icon={!userAvatar && emptyAvatarView === EMPTY_AVATAR_VIEW.DEFAULT && <UserOutlined/>}
      size="small"
      {...props}
    >
      {!userAvatar && emptyAvatarView === EMPTY_AVATAR_VIEW.INITIALS && user?.firstName}
    </Avatar>
  );
};

export default memo(UserAvatar);

UserAvatar.propTypes = {
  user: PropTypes.object,
  src: PropTypes.string,
  emptyAvatarView: PropTypes.string,
  useOriginal: PropTypes.bool,
};

UserAvatar.defaultProps = {
  user: {},
  emptyAvatarView: EMPTY_AVATAR_VIEW.DEFAULT,
};
